<script setup lang="ts">
definePageMeta({
  layout: "empty",
});

const { t } = useI18n();
const localePath = useLocalePath();
const router = useRouter();
const route = useRoute();

const statusMessage = ref(t('checkout.paymentConfirmed'));
const countdown = ref(5);
const targetRedirect = localePath("/app");

const { data: transaction_id } = useAsyncData("transaction_id", async () => {
  return route.query.transaction_id as string;
});

onMounted(() => {
  const ltv = Number(route.query.value);
  const currency = (route.query.currency as string) || "EUR";
  const hasValue = Number.isFinite(ltv) && ltv > 0;

  safeCapture("checkout_completed", {
    transactionId: transaction_id.value,
    value: hasValue ? ltv : undefined,
    currency: hasValue ? currency : undefined,
    plan: (route.query.plan as string) || undefined,
  });

  const interval = setInterval(() => {
    if (countdown.value <= 0) {
      clearInterval(interval);
      router.replace(targetRedirect);
    } else {
      countdown.value -= 1;
    }
  }, 1000);

  onBeforeUnmount(() => clearInterval(interval));
});
</script>

<template>
  <div class="flex min-h-screen items-center justify-center bg-gray-50 px-4">
    <div class="w-full max-w-sm rounded-2xl bg-white p-6 shadow">
      <div class="mb-4 flex items-center justify-center gap-3">
        <Icon
          name="heroicons:check-circle"
          class="size-8 text-emerald-500"
        />
        <h1 class="text-xl font-semibold text-gray-900">
          {{ t('checkout.paymentReceived') }}
        </h1>
      </div>
      <p class="text-sm text-gray-600">
        {{ statusMessage }}
      </p>
      <p class="mt-4 text-sm text-gray-500">
        {{ t('checkout.redirectIn', { countdown }) }}
      </p>
      <UProgress
        :value="((5 - countdown) / 5) * 100"
        color="primary"
        class="mt-4"
      />
      <UButton
        class="mt-6 w-full justify-center"
        color="primary"
        @click="router.replace(targetRedirect)"
      >
        {{ t('checkout.continue') }}
      </UButton>
    </div>
  </div>
</template>
